import { initializeApp } from 'firebase/app';
import { CompetitionService } from './../competition-service/competition-service';
import {
  CountryData,
  LeagueSeasonGuestView,
  CustomizedAttributes,
  LeagueSeasonCompetitionView,
} from './../../data/mygolf.data';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BehaviorSubject, catchError, filter, map, Observable, Subscription, take } from 'rxjs';
import { ClubFlightService } from 'services/club-flight-service/club-flight-service';
import { SessionInfo } from 'src/data/authentication-info';
import {
  LeagueSeason,
  LeagueSeasonPlayer,
  PlayerHomeInfo,
  PlayerInfo,
  TournamentPlayerBasicView,
} from 'src/data/mygolf.data';
import * as globals from 'src/globals';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { EnvironmentService } from 'services/environment-service/environment-service.service';
import { ContentType, RemoteRequest } from 'src/remote-request';
import { Custom_RequestMethod } from 'services/common-service';
import { RemoteHttpService } from 'src/remote-http';
import * as global from 'globals';
import { LoadingController } from '@ionic/angular';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AppCustomizerService implements OnDestroy {
  /**
   * behaviourSubjects for
   * clubId
   * clubInfo
   * organizerId
   * leagueId
   * seasonId
   * isQueryParam
   * selClubMembership
   * homeClubMembership
   * isClubSpecific: boolean
   * clubSpecificSelected
   *  */
  appClient: string = globals?.appClient?.toLowerCase();
  currentPlayerDetails: PlayerInfo;
  currentPlayerId: number = 0;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;

  private readonly STORAGE_KEY = 'customizedAttributes';

  constructor(
    private flightService: ClubFlightService,
    private router: Router,
    private playerHomeService: PlayerHomeDataService,
    private sessionService: SessionDataService,
    private playerHomeActions: PlayerHomeActions,
    private sessionActions: SessionActions,
    private environmentService: EnvironmentService,
    public requestMethod: Custom_RequestMethod,
    public http: RemoteHttpService,
    public loader: LoadingController,
    private compService: CompetitionService,
    private storage: MyGolfStorageService
  ) {
    sessionActions.onLogout$.subscribe(() => this.cleanupSubscriptions());
    if (global.appClient === 'WAGC') {
      this.setSubsidiary('wagc', 'init');
    } else if (global.appClient?.includes('WAGC-')) {
      this.setSubsidiary('WAGC_MYS', 'init');
    } else if (global.appClient?.includes('EPSL')) {
      this.setSubsidiary('EPSL', 'init');
    } else {
      this.setSubsidiary(null, 'init');
    }

    this.loadCustomizedAttributesFromStorage();

    this.playerHomeActions.setNeedRefresh(true);
    // this.subPlayerHomeInfo =
    this.playerHomeService.playerHomeInfo().subscribe((playerHome: PlayerHomeInfo) => {
      console.debug('[init customizer] season player home [info]', playerHome);
      if (playerHome?.player) {
        this.currentPlayerDetails = playerHome?.player ?? null;
        this.sessionService
          .getSession()
          .pipe(take(1))
          .subscribe((session: SessionInfo) => {
            this.currentPlayerId = session?.playerId;
            console.debug('[init customizer] current player [session]', session);
          });
        this.refreshCustomizedAttributes();
      } else {
        this.currentPlayerDetails = null;
        this.setSeasonDetails(null);
        this.setRosterDetails(null);
        this.refreshCustomizedAttributes();
      }
    });
  }

  subPlayerHomeInfo: Subscription;

  private loadCustomizedAttributesFromStorage() {
    this.storage.getPreference(this.STORAGE_KEY).subscribe(
      (cachedAttributes: CustomizedAttributes) => {
        if (cachedAttributes) {
          console.debug(
            '[AppCustomizerService] Loading customizedAttributes from localStorage',
            cachedAttributes
          );
          this.setCustomizedAttributes(cachedAttributes, 'cached');
        } else {
          console.debug('[AppCustomizerService] No cached customizedAttributes found');
        }
      },
      error => {
        console.error('[AppCustomizerService] Error loading from localStorage', error);
      }
    );
  }

  private saveCustomizedAttributesToStorage(attributes: CustomizedAttributes) {
    this.storage.setPreference(this.STORAGE_KEY, attributes).subscribe(
      () => {
        console.debug(
          '[AppCustomizerService] Saved customizedAttributes to localStorage',
          attributes
        );
      },
      error => {
        console.error('[AppCustomizerService] Error saving to localStorage', error);
      }
    );
  }

  // load customized-attributes locally or from server
  // redirect url/page method
  /***
   * setClubSpecific
   * setClubId
   * isQueryParam
   * setPersistClubTheme - 'communal' | String(clubId) | null for clearing
   * setSearchCompetition - can be for clubId, organizerId, partOfLeague
   * setSearchTeeBookings
   * setClubMembership
   * setHomeClub
   * changeTheme - reads clubSpecificThemes
   *  -> updateColor(themeName, reset?)
   * goToHomepage
   * goToProfile
   * goToSignUp
   */
  /**
   * customized pages :
   * sign-in
   * sign-up
   * player-home
   * profile
   * competition-filter
   * tabs.page (footer)
   * index (splash logo/animation-lottie)
   */

  subCustAttribute: Subscription;
  customizedAttributes: BehaviorSubject<CustomizedAttributes> = new BehaviorSubject({
    subsidiary: '',
    organizerId: null,
    displayName: '',
    clubId: null,
    signInLogo: '',
    menuItems: [],
    scoringEnabled: false,
    moreMenu: {
      show: false,
    },
    menuRows: 3,
    promotions: {
      show: false,
    },
    snpPackages: {
      show: false,
    },
    news: {
      show: false,
    },
    topLogoUrl1: null,
    topLogoUrl2: null,
    membership: {},
    leagueSeasons: {
      currentSeason: {
        seasonId: 0,
      },
      nextSeason: {
        seasonId: 0,
      },
    },
    showFooter: true,
    footerItems: [],
  });

  currentSeasonId: number = 0; // = new BehaviorSubject<number>(0);
  nextSeasonId: number = 0; // = new BehaviorSubject<number>(0);
  allCustomizedAttributes: BehaviorSubject<any> = new BehaviorSubject({});
  refreshCustomizedAttributes() {
    // if (this.subCustAttribute) return;
    // this.subCustAttribute = this.flightService.getCustomizedAttributes(true, false).subscribe(

    let _subsidiary = this.subsidiary.getValue();
    this.subCustAttribute = this._getCustomizedAttributes(true, globals.devMode).subscribe(
      (dataList: Array<any>) => {
        if (dataList?.length) {
          console.debug(
            '[appcustomizer] refresh customizedattributes ',
            dataList,
            this.subsidiary.getValue(),
            _subsidiary
          );
          const data = dataList?.find(dl => dl?.subsidiary === _subsidiary);
          this.setAllCustomizedAttributes(dataList);
          if (data === undefined || !data?.organizerId) {
            this.resetCustomizedAttributes();
            this.setCustomizedAttributes(null);
            this.setOrganizerId(null);
            this.setSubsidiary(null);
            this.setSubsidiaryDetails({
              clubId: null,
              organizer: null,
              displayName: null,
              subsidiary: null,
              themeName: null,
            });
          } else {
            console.debug('get customizedattribute : ', dataList, _subsidiary, data);
            this.localAttributes = data;
            console.debug('[appcustomizerservice] customized attributes', data);
            // this.setCurrentSeason(Number(data?.leagueSeasons?.currentSeason?.seasonId));
            this.currentSeasonId = Number(data?.leagueSeasons?.currentSeason?.seasonId);
            this.nextSeasonId = Number(data?.leagueSeasons?.nextSeason?.seasonId);

            this.refreshSeasonDetails();
            this.setCustomizedAttributes(data, 'refresh');
            this.setOrganizerId(data?.organizerId);
            this.setSubsidiary(data?.subsidiary, 'refresh');
            this.setSubsidiaryDetails({
              clubId: data?.clubId,
              organizer: data?.organizerId,
              displayName: data?.displayName,
              subsidiary: data?.subsidiary,
              themeName: data?.themeName,
            });
          }
          if (global.appClient?.length) {
            // const loader = this.loader
            //   .create({ showBackdrop: true, message: 'Applying theme...', duration: 2000 })
            //   .then(l => l.present());
            setTimeout(() => {
              this.applySubsidiaryTheme(_subsidiary);

              // this.loader.dismiss();
              // if (loader)
              //   loader.finally(() => {
              //     this.loader.dismiss();
              //   });
            }, 500);
          }
        }
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      },
      error => {
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      }
    );
  }

  forceRefreshCustomizedAttributes() {
    console.debug(
      '[AppCustomizerService] Force refreshing customizedAttributes from server (skipping localStorage)'
    );
    let _subsidiary = this.subsidiary.getValue();
    this.subCustAttribute = this._getCustomizedAttributes(true, globals.devMode).subscribe(
      (dataList: Array<any>) => {
        if (dataList?.length) {
          console.debug(
            'force refresh customizedattributes ',
            dataList,
            this.subsidiary.getValue(),
            _subsidiary
          );
          let designMode = 0;
          const data = dataList?.find(dl => dl?.subsidiary === _subsidiary);
          this.setAllCustomizedAttributes(dataList);
          if (data === undefined || !data?.organizerId) {
            this.resetCustomizedAttributes();
            this.setCustomizedAttributes(null);
            this.setOrganizerId(null);
            this.setSubsidiary(null);
            this.setSubsidiaryDetails({
              clubId: null,
              organizer: null,
              displayName: null,
              subsidiary: null,
              themeName: null,
            });
          } else {
            console.debug('get customizedattribute : ', dataList, _subsidiary, data);
            this.localAttributes = data;
            console.debug('customized attributes', data);
            this.currentSeasonId = Number(data?.leagueSeasons?.currentSeason?.seasonId);
            this.nextSeasonId = Number(data?.leagueSeasons?.nextSeason?.seasonId);

            this.refreshSeasonDetails();
            this.setCustomizedAttributes(data, 'forceRefresh');
            this.setOrganizerId(data?.organizerId);
            this.setSubsidiary(data?.subsidiary, 'forceRefresh');
            this.setSubsidiaryDetails({
              clubId: data?.clubId,
              organizer: data?.organizerId,
              displayName: data?.displayName,
              subsidiary: data?.subsidiary,
              themeName: data?.themeName,
            });
            if (this.localAttributes?.initDesignMode !== undefined) {
              designMode = this.localAttributes.initDesignMode;
            }
          }
          if (global.appClient?.length) {
            setTimeout(() => {
              this.applySubsidiaryTheme(_subsidiary, null, designMode);
            }, 500);
          }
        }
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      },
      error => {
        console.error('[AppCustomizerService] Error force refreshing customizedAttributes', error);
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      }
    );
  }

  applySubsidiaryTheme(subsidiary: string, themeName?: string, designMode?: number) {
    console.debug(
      '[update theme] subsidiary theme : ',
      subsidiary,
      themeName,
      designMode,
      global.appClient
    );
    if (global.appType !== 'main' && global.appClient?.length && subsidiary === 'epsl') {
      document.body.className = 'theme-' + 'epsl';
    } else if (global.appType !== 'main' && global.appClient?.length && subsidiary === 'wagc') {
      document.body.className = 'theme-' + 'wagc';
    } else if (global?.appClient?.length && global.appClient === 'EPSL') {
      document.body.className = 'theme-' + 'epsl';
    } else if (global.appType !== 'main' && global.appClient?.length && themeName) {
      document.body.className = `theme-${themeName}`;
    } else {
      document.body.className = '';
    }
  }

  localAttributes: any;

  setCustomizedAttributes(data, origin?: string) {
    console.debug('[AppCustomizerService] setting local customized attributes : ', origin, data);
    this.customizedAttributes.next(data);
    if (data) {
      this.saveCustomizedAttributesToStorage(data);
    }
  }

  getCustomizedAttributes() {
    return this.customizedAttributes.asObservable();
  }

  resetCustomizedAttributes() {
    const _reset = {
      menuItems: [],
      scoringEnabled: false,
      moreMenu: {
        show: false,
      },
      menuRows: 3,
      promotions: {
        show: false,
      },
      snpPackages: {
        show: false,
      },
      news: {
        show: false,
      },
      topLogoUrl1: null,
      topLogoUrl2: null,
      membership: {},
      leagueSeasons: {
        currentSeason: {
          seasonId: 0,
        },
        nextSeason: {
          seasonId: 0,
        },
      },
      showFooter: true,
      footerItems: [],
    };
    this.setCustomizedAttributes(_reset, 'reset');
  }

  goToPlayerHome() {
    console.debug('go to player home', this.appClient, globals);
    if (globals?.appType === 'club' && globals?.appClient?.length) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else if (globals?.appClient?.toLowerCase()?.includes('wagc')) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else if (globals?.appClient?.length && globals?.appClient !== null) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else {
      this.router.navigate(['/tabs/player-home'], { replaceUrl: true });
    }
  }
  goToPlayerProfile(params: NavigationExtras) {
    console.debug('go to player profile', this.appClient);
    this.router.navigate([`/tabs/${this.appClient}-profile`], params);
  }

  redirectHomePage() {
    if (globals?.appType === 'club' && globals?.appClient?.length) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else if (globals?.appClient?.toLowerCase()?.includes('wagc')) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else if (globals?.appClient?.length && globals?.appClient !== null) {
      this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    } else {
      return '/tabs/player-home';
    }
  }

  refreshSeasonDetails() {
    // this.currentSeasonId.subscribe((seasonId) => {
    console.debug('season details ', this.currentSeasonId);
    // ! TEST ONLY
    // this.currentSeasonId = 54;
    this.flightService
      .getSingleLeagueSeason(this.currentSeasonId)
      .subscribe((season: LeagueSeason) => {
        console.debug('season details ', season, this.currentPlayerDetails);
        this.setSeasonDetails(season);
        setTimeout(() => {
          this.refreshRosterDetails();
          this.refreshPlayerActiveRound();
          this.getRounds();
        }, 500);
      });
    // })
  }

  leagueSeasonDetails: BehaviorSubject<LeagueSeason> = new BehaviorSubject<LeagueSeason>(
    null
  ) as BehaviorSubject<LeagueSeason>;
  getSeasonDetails() {
    return this.leagueSeasonDetails.asObservable();
  }

  setSeasonDetails(season: LeagueSeason) {
    this.leagueSeasonDetails.next(season);
  }

  seasonRosterDetails: BehaviorSubject<TournamentPlayerBasicView & LeagueSeasonGuestView> =
    new BehaviorSubject<LeagueSeasonPlayer>(null) as BehaviorSubject<
      TournamentPlayerBasicView & LeagueSeasonGuestView
    >;
  currentPlayerRosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView = null;
  refreshRosterDetails() {
    const playerId = this.currentPlayerDetails?.playerId; // || this.currentPlayerId;
    const organizerId = globals?.organizerId;
    this.flightService
      .getMultiCoursePlayerDetails(organizerId, this.currentSeasonId, playerId)
      // .getSeasonRosterPlayerDetails(this.currentSeasonId, playerId)
      .subscribe(
        (rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) => {
          console.debug('roster details ', rosterDetails);
          if (rosterDetails) {
            this.currentPlayerRosterDetails = rosterDetails;
            // this.currentPlayerRosterDetails['participantType'] = 'Golfer';
            this.setRosterDetails(rosterDetails);
          } else {
            this.currentPlayerRosterDetails = null;
            // this.currentPlayerRosterDetails['participantType'] = 'Visitor';
            this.setRosterDetails(null);
          }
        },
        error => {
          console.debug('error roster details : ', error);
          this.currentPlayerRosterDetails = null;
          // this.currentPlayerRosterDetails['participantType'] = 'Visitor';
          this.setRosterDetails(null);
          if (typeof error === 'string' && error?.toLowerCase().includes('playernotfound')) {
            this.refreshGuestDetails();
          }
        }
      );
  }

  refreshGuestDetails() {
    const playerId = this.currentPlayerDetails?.playerId; // || this.currentPlayerId;
    const organizerId = globals?.organizerId;
    this.flightService
      .getMultiCourseGuestDetails(organizerId, this.currentSeasonId, playerId)
      // .getSeasonRosterPlayerDetails(this.currentSeasonId, playerId)
      .subscribe(
        (rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) => {
          console.debug('roster details ', rosterDetails);
          if (rosterDetails) {
            this.currentPlayerRosterDetails = rosterDetails;
            // this.currentPlayerRosterDetails['participantType'] = 'Guest';
            this.setRosterDetails(rosterDetails);
          } else {
            this.currentPlayerRosterDetails = null;
            // this.currentPlayerRosterDetails['participantType'] = 'Visitor';
            this.setRosterDetails(null);
          }
        },
        error => {
          console.debug('error guest details : ', error);
          this.currentPlayerRosterDetails = null;
          // this.currentPlayerRosterDetails['participantType'] = 'Visitor';
          this.setRosterDetails(null);
        }
      );
  }

  getRosterDetails() {
    return this.seasonRosterDetails.asObservable();
  }

  setRosterDetails(rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) {
    this.seasonRosterDetails.next(rosterDetails);
  }

  getRosterInfo(attribute: string) {
    // console.debug('get roster info : ', this.currentPlayerRosterDetails, attribute);
    if (!this.currentPlayerRosterDetails && attribute === 'groupColor') {
      return 'transparent';
    }
    if (!this.currentPlayerRosterDetails && attribute === 'participantType') {
      return 'Visitor';
    }
    if (!this.currentPlayerRosterDetails) {
      return;
    }
    const rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView =
      this.currentPlayerRosterDetails;
    switch (attribute) {
      case 'streamInfo':
        return rosterDetails?.competitionStream;
      case 'categoryInfo':
        return rosterDetails?.competitionPlayerCategory;
      case 'streamId':
        return rosterDetails?.competitionStream?.id;
      case 'categoryId':
        return rosterDetails?.competitionPlayerCategory?.id;
      case 'stream':
        return rosterDetails?.competitionStream?.name;
      case 'category':
        return rosterDetails?.competitionPlayerCategory?.name;
      case 'groupColor':
        return rosterDetails?.playerGroup?.groupColor || 'transparent';
      case 'groupName':
        return rosterDetails?.playerGroup?.name;
      case 'playerImage':
        if (!rosterDetails?.player?.image) {
          if (rosterDetails?.player?.gender === 'M') {
            return 'assets/image/homeImg/male_golfer.png';
          } else if (rosterDetails?.player?.gender === 'F') {
            return 'assets/image/homeImg/female_golfer.png';
          }
        }
        return rosterDetails?.player?.image;
      case 'handicapIndex':
        return rosterDetails?.initialHandicapIndex || rosterDetails?.handicapIndex;
      case 'initialHandicapIndex':
        return rosterDetails?.initialHandicapIndex || rosterDetails?.handicapIndex;
      case 'playerName':
        return rosterDetails?.player?.playerName;
      case 'playerId':
        return rosterDetails?.player?.id;
      case 'teamName':
        return rosterDetails?.teamName;
      case 'isCaptain':
        return rosterDetails?.captain;
      case 'participatingClub':
        return rosterDetails?.participatingClub;
      case 'partCountry':
        return rosterDetails?.participatingClub?.country;
      case 'partCountryFlag':
        const _flagUrl = rosterDetails?.participatingClub?.country
          ? `${global.MygolfServer}/${rosterDetails?.participatingClub?.country?.flagUrl}`
          : null;
        // console.debug("part country flag : ", _flagUrl)
        return _flagUrl;
      case 'participantType':
        const _length = rosterDetails?.participantType?.length;
        const _participantType =
          rosterDetails?.participantType[0] +
          rosterDetails?.participantType?.substring(1, _length)?.toLowerCase();
        return _participantType; // rosterDetails?.participantType;

      case 'isRegistered':
        return rosterDetails;
    }
  }

  ngOnDestroy() {
    this.cleanupSubscriptions();
    this.setSeasonDetails(null);
    this.setRosterDetails(null);
    this.setCustomizedAttributes(null);
    this.currentPlayerDetails = null;
  }

  public cleanupSubscriptions() {
    if (this.subCustAttribute) {
      this.subCustAttribute.unsubscribe();
      this.subCustAttribute = null;
    }
    if (this.subPlayerHomeInfo) {
      this.subPlayerHomeInfo.unsubscribe();
      this.subPlayerHomeInfo = null;
    }
    // this.storage.removePreference(this.STORAGE_KEY);
  }

  public _getCustomizedAttributes(initial: boolean = false, local: boolean = false) {
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (local && this.environmentService.isLocalhost()) {
      local = true;
    } else {
      local = false;
    }
    local = false;
    if (local) {
      _url = '/assets/customized-attributes.json' + '?v=' + _randomizer;
    } else {
      if (!initial) {
        if (globals?.clubId && globals?.appClient?.length) {
          _url =
            globals.MygolfServer +
            `/document/assets/clubSpecific/${globals?.clubId}/customized-attributes.json` +
            '?v=' +
            _randomizer;
        } else {
          _url =
            globals.MygolfServer +
            '/document/assets/customized-attributes.json' +
            '?v=' +
            _randomizer;
        }
      } else {
        const _env = globals.MygolfServerHost?.split('.')[0];
        _url = `https://applet.mygolf2u.com/api/attributes?env=${_env}`;
        // _url =
        //   'http://app.mygolf2u.com/settings' + '/customized-attributes.json' + '?v=' + _randomizer;
      }
    }
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          if (initial && !local) {
            return data?.sort((a, b) => {
              return b?.id - a?.id;
            })[0]?.data;
          }
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  subsidiary: BehaviorSubject<string> = new BehaviorSubject(null);

  getSubsidiary() {
    return this.subsidiary.asObservable();
  }

  setSubsidiary(subsidiary: string, origin?: string) {
    console.debug('[AppCustomizerService] Set Subsidiary', subsidiary, origin);
    this.subsidiary.next(subsidiary);
  }

  onSetSubsidiary(subsidiary: string, origin?: string) {
    return new Promise((resolve, reject) => {
      console.debug('[AppCustomizerService] On Set Subsidiary', subsidiary, origin);
      this.subsidiary.next(subsidiary);
      resolve(true);
    });
  }

  organizerId: BehaviorSubject<number> = new BehaviorSubject(globals.organizerId);

  getOrganizerId() {
    return this.organizerId.asObservable();
  }

  setOrganizerId(organizerId: number) {
    this.organizerId.next(organizerId);
  }

  subsidiaryDetails: BehaviorSubject<any> = new BehaviorSubject({
    id: 'wagc',
    displayName: 'WAGC',
    clubId: 28101309,
  });

  setSubsidiaryDetails(subsidiaryDetails: any) {
    this.subsidiaryDetails.next(subsidiaryDetails);
  }

  getSubsidiaryDetails() {
    return this.subsidiaryDetails.asObservable();
  }

  refreshCountryList() {
    this.flightService.getCountryList().subscribe((countryList: Array<CountryData>) => {
      this.setCountryList(countryList);
    });
  }

  countryList: BehaviorSubject<Array<CountryData>> = new BehaviorSubject([]);
  getCountryList() {
    return this.countryList.asObservable();
  }

  setCountryList(countries: Array<CountryData>) {
    this.countryList.next(countries);
  }

  getAllCustomizedAttributes() {
    return this.allCustomizedAttributes.asObservable();
  }

  setAllCustomizedAttributes(list: any) {
    this.allCustomizedAttributes.next(list);
  }

  setCompWAGCCountry(wagcCountry: any) {
    if (!wagcCountry) {
      return;
    }
    let searchCriteria = this.compService.getSearch();
    searchCriteria.wagcCountry = wagcCountry;
    searchCriteria.organizerId = wagcCountry?.organizer?.id;
    this.compService.setSearch(searchCriteria);
  }

  bypassLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);

  getBypassLogin() {
    return this.bypassLogin.asObservable();
  }
  setBypassLogin(setValue: boolean) {
    this.bypassLogin.next(setValue);
  }

  clubWebParam: BehaviorSubject<number> = new BehaviorSubject(0);
  setClubWebParam(clubId: number) {
    this.clubWebParam.next(clubId);
  }
  getClubWebParam() {
    return this.clubWebParam.asObservable();
  }

  needRefreshMCTDetails: BehaviorSubject<boolean> = new BehaviorSubject(false);
  getRefreshMCTDetails() {
    return this.needRefreshMCTDetails.asObservable();
  }
  setRefreshMCTDetails(value: boolean) {
    this.needRefreshMCTDetails.next(value);
  }

  multiCourseRounds: BehaviorSubject<any> = new BehaviorSubject(null);
  setMultiCourseRounds(value: any) {
    this.multiCourseRounds.next(value);
  }

  getMultiCourseRounds() {
    return this.multiCourseRounds.asObservable();
  }

  getRounds(leagueSeason?: LeagueSeason) {
    let _orgId = global.organizerId; // this.leagueSeasonDetails? .league?.organizer?.id;
    let _seasonId = this.currentSeasonId;
    this.flightService
      .getMultiCourseCompRounds(_orgId, _seasonId)
      .subscribe((leagueRounds: Array<LeagueSeasonCompetitionView>) => {
        if (leagueRounds?.length) {
          this.setMultiCourseRounds(leagueRounds);

          // let navigationExtras: NavigationExtras = {
          //   state: {
          //     seasonId: this.currentSeasonId,
          //     leagueSeason: this.leagueSeason,
          //     competitionRounds: this.multiCourseRounds,
          //   },
          // };
          // this.router.navigate(['tabs/multi-course-competition-rounds'], navigationExtras);
        }
      });
  }

  playerActiveRound: BehaviorSubject<any> = new BehaviorSubject(null);

  getPlayerActiveRound() {
    return this.playerActiveRound.asObservable();
  }

  setPlayerActiveRound(value) {
    this.playerActiveRound.next(value);
  }

  refreshPlayerActiveRound() {
    const playerId = this.currentPlayerDetails?.playerId;

    let params = {
      playerId: playerId,
      asOf: moment().format('YYYY-MM-DD'),
    };
    this.flightService.getMCTPlayerActiveRound(params).subscribe(data => {
      this.setPlayerActiveRound(data);
    });
  }
}
